import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import posthog from "@/lib/posthog";

export default function PostHogPageTracker() {
  const location = useLocation();

  useEffect(() => {
    posthog.capture("$pageview");
  }, [location.pathname, location.search]);

  return null;
}
